import React, { useId, useRef } from 'react';
import cs from 'classnames';
import { useField } from 'formik';

interface Props {
  name: string;
  label?: string;
  labelDirection?: 'right' | 'left';
  fullWidth?: boolean;
}

const FormFieldSwitch: React.FC<Props> = ({ name, label, labelDirection = 'right', fullWidth }) => {
  const labelRef = useRef<HTMLLabelElement>(null);
  const [{ value }, , { setValue }] = useField(name);

  const id = useId();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.checked);
  };

  const classes = cs(
    'ss-w-16 ss-relative ss-cursor-pointer ss-h-8 ss-rounded-full ss-duration-300',
    {
      'ss-bg-success-600': value,
      'ss-bg-neutral-200': !value
    }
  );

  return (
    <div
      className={cs('ss-flex ss-items-center ss-gap-3', {
        'ss-w-full': fullWidth,
        'ss-w-max': !fullWidth
      })}>
      {label && labelDirection === 'left' && (
        <span
          className={cs('ss-cursor-pointer ss-text-text-sm', {
            'ss-flex-1': fullWidth
          })}
          onClick={() => labelRef.current?.click()}>
          {label}
        </span>
      )}
      <label ref={labelRef} htmlFor={id || name} className={classes}>
        <input
          checked={value}
          type="checkbox"
          className="ss-hidden"
          name={name}
          onChange={handleChange}
          id={id || name}
        />
        <span
          style={{
            boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06)'
          }}
          className={cs(
            'ss-w-6 ss-h-6 ss-duration-300 ss-top-2/4 ss-transform ss--translate-y-2/4 ss-rounded-full ss-absolute ss-text-neutral-50 ss-flex ss-justify-center ss-items-center',
            {
              'ss-bg-white ss-left-1': !value,
              'ss-bg-white ss-left-9': value
            }
          )}></span>
      </label>
      {label && labelDirection === 'right' && (
        <span
          className="ss-cursor-pointer ss-text-text-sm"
          onClick={() => labelRef.current?.click()}>
          {label}
        </span>
      )}
    </div>
  );
};

export default FormFieldSwitch;
